var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
var SvgSentimentSatisfied = function SvgSentimentSatisfied(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#sentiment_satisfied_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#27C595",
    d: "M12.99 2.167C7.01 2.167 2.166 7.02 2.166 13s4.842 10.833 10.822 10.833c5.991 0 10.844-4.853 10.844-10.833S18.98 2.167 12.99 2.167m.01 19.5A8.664 8.664 0 0 1 4.333 13 8.664 8.664 0 0 1 13 4.333 8.664 8.664 0 0 1 21.667 13 8.664 8.664 0 0 1 13 21.667m3.792-9.75c.899 0 1.625-.726 1.625-1.625 0-.9-.726-1.625-1.625-1.625-.9 0-1.625.725-1.625 1.625 0 .899.726 1.625 1.625 1.625m-7.584 0c.9 0 1.625-.726 1.625-1.625 0-.9-.726-1.625-1.625-1.625s-1.625.725-1.625 1.625c0 .899.726 1.625 1.625 1.625M13 18.958c2.524 0 4.67-1.581 5.536-3.791H7.464c.867 2.21 3.012 3.791 5.536 3.791"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "sentiment_satisfied_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h26v26H0z"
  })))));
};
export default SvgSentimentSatisfied;